import { getTemplates, getTemplateComponents, listEmployeeSalaryStructures } from "../../../SalaryApi";
import { v2ListComponents } from "../../SalaryApiV2";
import { formulaOf } from "../../wizard/shared";
import {
  clearPipelineState,
  PIPELINE_STEPS,
  writePipelineState,
} from "./salaryTemplatePipeline";

/**
 * Hydrate pipeline draft from an existing salary template (edit flow).
 */
export async function loadTemplateIntoPipeline(templateId) {
  const id = String(templateId || "").trim();
  if (!id) throw new Error("Template ID is required.");

  const [templates, mappings, allComps] = await Promise.all([
    getTemplates(),
    getTemplateComponents(id),
    v2ListComponents(),
  ]);

  const tpl = (Array.isArray(templates) ? templates : []).find(
    (t) => String(t.template_id) === id
  );
  if (!tpl) throw new Error("Salary structure not found.");

  const mapRows = Array.isArray(mappings) ? mappings : [];
  const ids = mapRows.map((m) => String(m.component_id)).filter(Boolean);
  const compById = new Map((allComps || []).map((c) => [String(c.component_id), c]));

  const formulas = {};
  for (const cid of ids) {
    const comp = compById.get(cid);
    if (!comp) continue;
    const expression = String(formulaOf(comp) || comp.formula_expression || "").trim();
    if (expression) formulas[cid] = { expression };
  }

  let draftEmployeeAssignments = [];
  let targetAnnualCtc = null;
  try {
    const assignments = await listEmployeeSalaryStructures();
    const rows = (Array.isArray(assignments) ? assignments : []).filter(
      (a) => String(a.template_id) === id
    );
    draftEmployeeAssignments = rows.map((r) => ({
      employee_id: r.employee_id,
      employee_name: r.employee_name,
      employee_code: r.employee_code,
      ctc: r.ctc,
    }));
    const ctcs = [...new Set(rows.map((r) => Number(r.ctc)).filter((n) => Number.isFinite(n) && n > 0))];
    if (ctcs.length === 1) targetAnnualCtc = ctcs[0];
  } catch {
    /* optional */
  }

  clearPipelineState();
  return writePipelineState({
    active: true,
    editMode: true,
    templateId: id,
    templateName: tpl.name || "",
    templateDescription: tpl.description || "",
    allocatedComponentIds: ids,
    formulas,
    targetAnnualCtc,
    draftEmployeeAssignments,
    currentStep: PIPELINE_STEPS.template,
    _pipelineVersion: 2,
  });
}
